import React, {FC} from "react";
import * as fa from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface NumericMetricTileProps {
  type: 'numeric'
  title: string
  subText: string
  currentPeriod: number
  previousPeriod: number
  icon?: fa.IconDefinition
}

interface PercentageMetricTileProps {
  type: 'percentage'
  title: string
  subText: string
  currentPeriod: number
  previousPeriod: number
  icon?: fa.IconDefinition
}

type MetricProps = NumericMetricTileProps | PercentageMetricTileProps


export const MetricTile: FC<MetricProps> = props => {
  return <div className={'bg-brand-secondary-container rounded-xl px-6 py-5 col-span-1 flex flex-col '}>
    <div className={'flex flex-row space-x-2 items-center text-brand-on-primary-container font-bold mb-2'}>
      {props.icon && <FontAwesomeIcon icon={props.icon} />}
      <div>{props.title}</div>
    </div>

    <div className={'flex-1 text-sm text-brand-secondary'}>{props.subText}</div>
     <MetricTileContent {...props} />
  </div>
}

export const MetricTileContent: FC<MetricProps> = props => {
  if (props.type === 'numeric') {
    const diff = props.currentPeriod - props.previousPeriod
    return <div className={"mt-2"}>
      <div className={"flex text-3xl"}>
        <span>{props.currentPeriod}</span>
        <span className={`text-xs ml-1 ${props.currentPeriod > props.previousPeriod ? 'text-green-600' : props.currentPeriod === props.previousPeriod ? 'text-amber-500' : 'text-red-500'}`}>
          {props.currentPeriod > props.previousPeriod ? `(+${diff})` : props.currentPeriod === props.previousPeriod ? `(${diff})` : `(${diff})`}
        </span>
      </div>
    </div>
  }

  if (props.type === 'percentage') {
    const diff = Math.round((props.currentPeriod - props.previousPeriod) * 10)/10
    return <div className={"mt-2"}>
      <div className={"flex text-3xl"}>
        <span>{props.currentPeriod}%</span>
        <span className={`text-xs ml-1 ${props.currentPeriod > props.previousPeriod ? 'text-green-600' : props.currentPeriod === props.previousPeriod ? 'text-amber-500' : 'text-red-500'}`}>
          {props.currentPeriod > props.previousPeriod ? `(+${diff}%)` : props.currentPeriod === props.previousPeriod ? `(${diff})` : `(${diff})`}
        </span>
      </div>
    </div>
  }
}



